<template>
  <div class="profile-page">
    <div class="user-info">
      <div @click="isEditAvatarOpen = true" class="user-image-wrapper">
        <img
          v-if="isImageLoaded && $auth.user().profile.avatar"
          :src="$auth.user().profile.avatar"
          class="user-image"
          @error="handleImageError"
        />
        <img v-else src="../../files/assets/images/default-user-image.png" class="user-image" />
      </div>

      <div class="user-name-block">
        <MainTitle class="user-name-title"
          >{{ $auth.user().profile.name }} {{ $auth.user().profile.second_name }}
          {{ $auth.user().profile.last_name }}</MainTitle
        >
        <main-text>{{ phone }}</main-text>
      </div>
    </div>

    <horizontal-menu :menuItems="menuItems" :activeMenuItem="activeMenuItem" @onMenuItemChange="handleMenuItemChange" />

    <user-form v-if="activeMenuItem === 'main-info'" />
    <change-password v-if="activeMenuItem === 'change-password'" />
    <license-keys v-if="activeMenuItem === 'license'" />
    <PaymentTab v-if="activeMenuItem === 'pay'" />

    <!-- Обновление аватара, width и height это валидация, совпадает с серверной. Пока не работает - бекенд 500 -->
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      :url="`${$http.defaults.baseURL}profile/update-avatar`"
      v-model="isEditAvatarOpen"
      langType="ru"
      :params="params"
      :headers="headers"
      img-format="png"
      :width="800"
      :height="800"
    ></my-upload>
  </div>
</template>

<script>
import MainTitle from "../ui/MainTitle.vue";
import AccountUserForm from "../AccountUserForm.vue";
import ChangePassword from "../ChangePassword.vue";
import Text from "../ui/Text.vue";
import myUpload from "vue-image-crop-upload";
import LicenseKeys from "../LicenseKeys.vue";
import PaymentTab from "../PaymentTab.vue";
import { USER_PAGE_MENU_ITEMS } from "../../constants/constants";
import HorizontalMenu from "../HorizontalMenu.vue";

export default {
  data() {
    return {
      phone: "",
      email: "",
      activeMenuItem: "main-info",
      menuItems: USER_PAGE_MENU_ITEMS,
      isEditAvatarOpen: false,
      isImageLoaded: true,
      params: {
        token: "123456798",
        name: "avatar",
        langType: "en",
      },
      headers: {
        Authorization: "Bearer " + this.$auth.token(),
      },
    };
  },

  components: {
    MainTitle,
    "main-text": Text,
    "user-form": AccountUserForm,
    myUpload,
    ChangePassword,
    LicenseKeys,
    PaymentTab,
    HorizontalMenu,
  },

  methods: {
    fetchUserSecurityData() {
      this.$http.get("user/security").then((response) => {
        this.phone = response.data.phone;
        this.email = response.data.email;
      });
    },

    handleMenuItemChange(menuItem) {
      this.activeMenuItem = menuItem;
    },

    cropUploadSuccess(jsonData) {
      this.$auth.user().profile.avatar = jsonData;
    },

    handleImageError() {
      this.isImageLoaded = false;
    },
  },

  created() {
    this.fetchUserSecurityData();
  },
};
</script>

<style scoped>
.profile-page {
  width: 100%;
  overflow: auto;
  padding: 32px;
}
.user-info {
  display: flex;
}
.user-name-block {
  margin-left: 16px;
}
.user-name-title {
  margin-bottom: 16px;
}
.user-image-wrapper {
  width: 120px;
  height: 120px;
  cursor: pointer;
}
.user-image {
  border-radius: 50%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}
</style>
